export default "__VITE_ASSET__DdeJ_jHz__"